import React from 'react'
import { CardModuleFullModel } from './models/CardModuleFull.model'
import CTAWithArrow from '../../react-only-components/CTAWithArrow'
import {
  Image,
  isEditorActive,
  Link,
  RichText,
  Text,
} from '@sitecore-jss/sitecore-jss-react'
import './style.scss'

import { anchorWithId } from '../../helpers/anchorWithId.helper'
import { ComponentProps } from '../../types/types'

interface CardModuleProps extends ComponentProps {}
const CardModuleFull = (props: CardModuleProps) => {
  const model = new CardModuleFullModel(props)
  const objImageTitle = model?.imageTitle?.value ?? '';
  const isEmptyImageTitle = Object.keys(objImageTitle).length === 0
  const bodyTextNotEmpty = model?.bodyText?.value?.length !== 0

  return (
    <>
      {props.fields && (
        <div className={'card-module'} id={props?.rendering?.uid}>
          <Image
            loading="lazy"
            field={model?.image}
            className="card-module__image desktopImage"
          />
          <Image
            loading="lazy"
            field={
              model?.imageMobile ?
              (Object.keys(model?.imageMobile?.value ?? []).length > 0
                ? model?.imageMobile
                : (model?.AllowFallbackForMobile ? model?.image : undefined)) : undefined
            }
            className="card-module__image mobileImage"
          />

          <div className="card-module__content__wrapper">
            {model.variant?.value === 'v1' ? (
              <div
                className={`
                  card-module__content card-module__content--desktop card-module__cntntB
                  ${
                    model?.bodyText?.value && model?.bodyText?.value?.length > 0
                      ? 'card-module__cntntB--diffLayout'
                      : 'card-module__cntntB--diffLayoutNoBT'
                  }
                  `}
              >
                {!isEmptyImageTitle && (
                  <img
                    className="ColumnCard__img"
                    src={model?.imageTitle?.value?.src}
                    alt={model?.imageTitle?.value?.alt as string}
                    width={model?.imageTitle?.value?.width as number}
                    height={model?.imageTitle?.value?.height as number}
                  />
                )}
                {isEmptyImageTitle && (
                  <Text
                    tag="h3"
                    field={model.title}
                    className={'card-module__title card-module__ttlA'}
                  />
                )}
                {bodyTextNotEmpty && (
                  <RichText
                    tag="div"
                    field={model.bodyText}
                    className={'card-module__description card-module__dscrA'}
                  />
                )}
                {(model.primaryLink?.text || model.primaryLink?.href) && (
                  <div className="card-module__cta cta cta-primary-white">
                    {isEditorActive() ? (
                      <Link field={model.primaryLink} />
                    ) : (
                      <Link field={model.primaryLink} />
                    )}
                  </div>
                )}
                {(model.secondaryLink?.text || model.secondaryLink?.href) && (
                  <div className="card-module__cta cta cta-primary-black">
                    {isEditorActive() ? (
                      <Link field={model.secondaryLink} />
                    ) : (
                      <CTAWithArrow
                        text={model?.secondaryLink?.text ?? ''}
                        href={anchorWithId(
                          model?.secondaryLink?.href ?? '',
                          model?.secondaryLink?.anchor
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            ) : model.variant?.value === 'v2' ? (
              <div className="card-module__content card-module__content--desktop card-module__cntntA">
                <Text
                  tag="h3"
                  field={model.title}
                  className={'card-module__title card-module__ttlB'}
                />
                <RichText
                  tag="div"
                  field={model.bodyText}
                  className={'card-module__description card-module__dscrB'}
                />
                {(model.primaryLink?.text || model.primaryLink?.href) && (
                  <div className="card-module__cta cta cta-primary-white">
                    {isEditorActive() ? (
                      <Link field={model.primaryLink} />
                    ) : (
                      <Link field={model.primaryLink} />
                    )}
                  </div>
                )}
                {(model.secondaryLink?.text || model.secondaryLink?.href) && (
                  <div className="card-module__cta cta cta-primary-black">
                    {isEditorActive() ? (
                      <Link field={model.secondaryLink} />
                    ) : (
                      <CTAWithArrow
                        text={model?.secondaryLink?.text ?? ''}
                        href={anchorWithId(
                          model?.secondaryLink?.href ?? '',
                          model?.secondaryLink?.anchor
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            ) : model.variant?.value === 'v3' ? (
              <div className="card-module__content card-module__content--desktop card-module__cntntA card-module__cntntAA">
                <Text
                  tag="h3"
                  field={model.title}
                  className={
                    'card-module__title card-module__ttlB card-module__ttlBB'
                  }
                />
                <RichText
                  tag="div"
                  field={model.bodyText}
                  className={
                    'card-module__description card-module__dscrB card-module__dscrBB'
                  }
                />
                {(model.primaryLink?.text || model.primaryLink?.href) && (
                  <div className="card-module__cta cta cta-primary-red">
                    {isEditorActive() ? (
                      <Link field={model.primaryLink} />
                    ) : (
                      <Link field={model.primaryLink} />
                    )}
                  </div>
                )}
                {(model.secondaryLink?.text || model.secondaryLink?.href) && (
                  <div className="card-module__cta cta cta-primary-black">
                    {isEditorActive() ? (
                      <Link field={model.secondaryLink} />
                    ) : (
                      <CTAWithArrow
                        text={model?.secondaryLink?.text ?? ''}
                        href={anchorWithId(
                          model?.secondaryLink?.href ?? '',
                          model?.secondaryLink?.anchor
                        )}
                      />
                    )}
                  </div>
                )}
              </div>
            ) : model.variant?.value === 'v4' ? (
              <div className="card-module__content card-module__content--desktop card-module__cntntA card-module__cntntAAB card-module__cntntAAB--alto">
                <Text
                  tag="h3"
                  field={model.title}
                  className={
                    'card-module__title card-module__ttlB card-module__ttlBBB'
                  }
                />
                <RichText
                  tag="div"
                  field={model.bodyText}
                  className={
                    'card-module__description card-module__dscrB card-module__dscrBB'
                  }
                />

                <div className="card-module__slide-cta__container">
                  <div>
                    <div className="stories__link slide__cta card-module__slide-cta">
                      {(model.primaryLink?.text || model.primaryLink?.href) && (
                        <>
                          {isEditorActive() ? (
                            <Link field={model.primaryLink} />
                          ) : (
                            <Link field={model.primaryLink} />
                          )}
                        </>
                      )}

                      {(model.secondaryLink?.text ||
                        model.secondaryLink?.href) && (
                        <>
                          {isEditorActive() ? (
                            <Link field={model.secondaryLink} />
                          ) : (
                            <CTAWithArrow
                              text={model?.secondaryLink?.text ?? ''}
                              href={anchorWithId(
                                model?.secondaryLink?.href ?? '',
                                model?.secondaryLink?.anchor
                              )}
                              color="darkest"
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>

          {model?.variant?.value === 'v1' ? (
            <div
              className={`
                  card-module__content card-module__content--mobile card-module__cntntB
                  ${
                    model?.bodyText?.value && model?.bodyText?.value?.length > 0
                      ? 'card-module__cntntB--diffLayout'
                      : 'card-module__cntntB--diffLayoutNoBT'
                  }
                  `}
            >
              {!isEmptyImageTitle && (
                <img
                  className="ColumnCard__img"
                  src={model?.imageTitle?.value?.src}
                  alt={model?.imageTitle?.value?.alt as string}
                  width={model?.imageTitle?.value?.width as number}
                  height={model?.imageTitle?.value?.height as number}
                />
              )}
              {isEmptyImageTitle && (
                <Text
                  tag="h3"
                  field={model.title}
                  className={'card-module__title card-module__ttlA'}
                />
              )}
              <RichText
                tag="div"
                field={model.bodyText}
                className={'card-module__description card-module__dscrA'}
              />
              {(model.primaryLink?.text || model.primaryLink?.href) && (
                <div className="card-module__cta card-module__cta--mobile  cta cta-primary-white">
                  {isEditorActive() ? (
                    <Link field={model.primaryLink} />
                  ) : (
                    <Link field={model.primaryLink} />
                  )}
                </div>
              )}
              {(model.secondaryLink?.text || model.secondaryLink?.href) && (
                <div className="card-module__cta card-module__cta--mobile  cta cta-primary-black">
                  {isEditorActive() ? (
                    <Link field={model.secondaryLink} />
                  ) : (
                    <CTAWithArrow
                      text={model?.secondaryLink?.text ?? ''}
                      href={anchorWithId(
                        model?.secondaryLink?.href ?? '',
                        model?.secondaryLink?.anchor
                      )}
                    />
                  )}
                </div>
              )}
            </div>
          ) : model?.variant?.value === 'v2' ? (
            <div className="card-module__content card-module__content--mobile card-module__cntntA">
              <Text
                tag="h3"
                field={model.title}
                className={'card-module__title card-module__ttlB'}
              />
              <RichText
                tag="div"
                field={model.bodyText}
                className={'card-module__description card-module__dscrB'}
              />
              {(model.primaryLink?.text || model.primaryLink?.href) && (
                <div className="card-module__cta card-module__cta--mobile  cta cta-primary-white">
                  {isEditorActive() ? (
                    <Link field={model.primaryLink} />
                  ) : (
                    <Link field={model.primaryLink} />
                  )}
                </div>
              )}
              {(model.secondaryLink?.text || model.secondaryLink?.href) && (
                <div className="card-module__cta card-module__cta--mobile  cta cta-primary-black">
                  {isEditorActive() ? (
                    <Link field={model.secondaryLink} />
                  ) : (
                    <CTAWithArrow
                      text={model?.secondaryLink?.text ?? ''}
                      href={anchorWithId(
                        model?.secondaryLink?.href ?? '',
                        model?.secondaryLink?.anchor
                      )}
                    />
                  )}
                </div>
              )}
            </div>
          ) : model?.variant?.value === 'v3' ? (
            <div className="card-module__content card-module__content--mobile card-module__cntntA card-module__cntntAAB">
              <Text
                tag="h3"
                field={model.title}
                className={
                  'card-module__title card-module__ttlB  card-module__ttlBBB'
                }
              />
              <RichText
                tag="div"
                field={model.bodyText}
                className={
                  'card-module__description card-module__dscrB card-module__dscrBB'
                }
              />
              {(model.primaryLink?.text || model.primaryLink?.href) && (
                <div className="stories__link slide__cta card-module__slide-cta">
                  {isEditorActive() ? (
                    <Link field={model.primaryLink} />
                  ) : (
                    <Link field={model.primaryLink} />
                  )}
                </div>
              )}
              {(model.secondaryLink?.text || model.secondaryLink?.href) && (
                <div className="stories__link slide__cta card-module__slide-cta">
                  {isEditorActive() ? (
                    <Link field={model.secondaryLink} />
                  ) : (
                    <CTAWithArrow
                      text={model?.secondaryLink?.text ?? ''}
                      href={anchorWithId(
                        model?.secondaryLink?.href ?? '',
                        model?.secondaryLink?.anchor
                      )}
                    />
                  )}
                </div>
              )}
            </div>
          ) : model?.variant?.value === 'v4' ? (
            <div className="card-module__content card-module__content--mobile card-module__cntntA card-module__cntntAAB card-module__cntntAAB--alto">
              <Text
                tag="h3"
                field={model.title}
                className={
                  'card-module__title card-module__ttlB  card-module__ttlBBB'
                }
              />
              <RichText
                tag="div"
                field={model.bodyText}
                className={
                  'card-module__description card-module__dscrB card-module__dscrBB'
                }
              />
              {(model.primaryLink?.text || model.primaryLink?.href) && (
                <div className="stories__link slide__cta card-module__slide-cta">
                  {isEditorActive() ? (
                    <Link field={model.primaryLink} />
                  ) : (
                    <Link field={model.primaryLink} />
                  )}
                </div>
              )}
              {(model.secondaryLink?.text || model.secondaryLink?.href) && (
                <div className="stories__link slide__cta card-module__slide-cta">
                  {isEditorActive() ? (
                    <Link field={model.secondaryLink} />
                  ) : (
                    <CTAWithArrow
                      text={model?.secondaryLink?.text ?? ''}
                      href={anchorWithId(
                        model?.secondaryLink?.href ?? '',
                        model?.secondaryLink?.anchor
                      )}
                      color="darkest"
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  )
}

export default CardModuleFull
